import React from 'react';
import { FormattedMessage } from 'react-intl';
import { observer } from 'mobx-react';

import style from './PartnerSetupError.module.scss';
import Typography from '../Typography/Typography';
import { rootStore } from '../../stores';
import { PartnerSetupError as ErrorReason } from '../../stores/PartnerStore';

/**
 * Shown instead of the configurator when a dealer embedding cannot be served (JOKA-305).
 * The dealer sees it on their own site as soon as they embed us, which is the point: the data has to be
 * fixed in the JOKA shop before the integration works.
 */
@observer
export class PartnerSetupError extends React.Component {
  render() {
    const { partnerStore } = rootStore;
    const reason = partnerStore.error ?? ErrorReason.ServiceUnavailable;

    return (
      <div className={style.root}>
        <div className={style.wrapper}>
          <Typography className={style.title} weight="bold">
            <FormattedMessage id={`partner.setup.error.${reason}.title`} />
          </Typography>
          <Typography className={style.description} weight="light">
            <FormattedMessage id={`partner.setup.error.${reason}.description`} />
          </Typography>
          {reason === ErrorReason.IncompleteData && (
            <ul className={style.fields}>
              {partnerStore.missingFields.map(field => (
                <li key={field} className={style.field}>
                  <Typography weight="bold">
                    <FormattedMessage id={`partner.setup.error.field.${field}`} />
                  </Typography>
                </li>
              ))}
            </ul>
          )}
          {partnerStore.kundennummer && (
            <Typography className={style.kundennummer} weight="light">
              <FormattedMessage
                id="partner.setup.error.kundennummer"
                values={{ kundennummer: partnerStore.kundennummer }}
              />
            </Typography>
          )}
        </div>
      </div>
    );
  }
}
